// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/hl7-front-library";
// Components
import JunoPage from "../../components/JunoPage/JunoPage";
// Translation
import i18n from "i18next";
import { toPublicUrl } from "../../services/PublicUrl";
// Styles
import "../Home/Home.css"

const Home: FunctionComponent = () => {
  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <JunoPage loading={false} fitFooter={true} needsLogin={false}>
      <>
        <div className="status-page home-page">
          <div>
            <img
              className="home-image-icon"
              alt="Home_image"
              src={toPublicUrl("/assets/home.png")}
            />
          </div>
          <div className="status-page-content">
            <Title
              level={1}
              prefix="Juno"
              content={i18n.t("title.usermanagement")}
            />
          </div>
        </div>
      </>
    </JunoPage>
  );
};

export default Home;
